    jQuery(document).on('ready', function() {
      jQuery(".collection-color-cls").slick({
        dots: false,
        infinite: true,
        // slidesToShow: 3,
        // slidesToScroll: 3
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        //autoplaySpeed: 2000,
        //centerMode: false,
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    //centerMode: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    //centerMode: true,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    //centerMode: true,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
      });

//alert('hello');
      
    });


$(function() {
      var $sidebar = $(".product__media-wrapper");
      var sidebarTop = $sidebar.position().top;
      var blogHeight = $(".product__info-wrapper").outerHeight();
  
  
      $(window).scroll(fixSidebarOnScroll);

      function fixSidebarOnScroll() {
  
        if ($(window).width() > 1250) {
          //alert('ababababaaba');
          var windowScrollTop = $(window).scrollTop();
          if (windowScrollTop <= sidebarTop) {
            $sidebar.removeClass("sticky");
            $(".price__badge-sale").removeClass("stickybadge");
          }
          else if (windowScrollTop >= sidebarTop) {
            if (!$sidebar.hasClass("sticky")) {
              $sidebar.addClass("sticky");
              $(".price__badge-sale").addClass("stickybadge");
            }
          }
        }
      }
  });